export default __webpack_public_path__ + "static/padmini-2306e858d2d4fd89189ff48c50386058.jpg";